import authReducer from '@/features/authSlice'
import dialogGroupSpotsReducer from '@/features/dialogGroupSpotsSlice'
import dialogPhotoReducer from '@/features/dialogPhotoSlice'
import dialogRewardsReducer from '@/features/dialogRewardsSlice'
import dialogReducer from '@/features/dialogSlice'
import raundReducer from '@/features/raundSlice'
import spotMapReducer from '@/features/spotMapSlice'
import { type Action, type ThunkAction, configureStore } from '@reduxjs/toolkit'

export const store = configureStore({
  reducer: {
    dialog: dialogReducer,
    dialogGroupSpots: dialogGroupSpotsReducer,
    dialogRewards: dialogRewardsReducer,
    dialogPhotoState: dialogPhotoReducer,
    raund: raundReducer,
    spotMap: spotMapReducer,
    auth: authReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

export type AppDispatch = typeof store.dispatch
